import Vue from 'vue';
import Vuex from 'vuex';
import EventEmitter from 'events'
import { ApiClient, Store } from '../components/RedbayComponents'
import createPersistedState from 'vuex-persistedstate'
import Cookies from "js-cookie";
import { STATUS_CODES } from 'http';
import { time } from 'locutus/php/datetime';
import Router from '../router/index';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export const storeEmitter = new EventEmitter();
export const INITIAL_DATA = 'api_start';

export const store = new Vuex.Store({
  struct: debug,
  modules: {
    ...Store(),
    demo:{
      namespaced: true,
      state:{
        enabled: false
      },
      mutations:{
        enableDemo(state){
          state.enabled = true;
        },
        disableDemo(state){
          state.enabled = false;
        }
      },
      actions:{
        enableDemo({commit}){
          commit('enableDemo');
        },
        disableDemo({commit}){
          commit('disableDemo');
        }
      }
    },
    logout: {
      namespaced: true,
      state: {
        MINUTES_UNTIL_LOGOUT: 30,
        CHECK_INTERVAL: 1000,
        lastAction: Date.now()
      },
      actions: {
        check({state, commit}) {
            let now = Date.now();
            let timeleft = state.lastAction + state.MINUTES_UNTIL_LOGOUT * 60 * 1000;
            let diff = timeleft - now;
            let isTimeout = diff < 0;
            store.dispatch('user/isAuthorized').then( authorized => {
              if(isTimeout && authorized) {
                store.dispatch('user/signout').then(()=> {
                  Router.push({path:"/"});
                  console.log("SESSION TIMEOUT! LOGGING OUT!");
                })
              }
            })
        },
        reset({state}) {
          state.lastAction = Date.now();
        }
      }
    }
  },
  state: {
    createdTicket: false,
    shop: null,
    breadcrumbVisible: false,
    breadcrumbPath: [],
    showRightWindow: false,
    showRightWindowOffer: false,
    searchBlock: false,
    menuVisible: '',
    notifications: [],
    demo: false
  },
  getters: {},
  mutations: {
    initializeShop(state, initialData) {
      state.shop = { ...initialData, name: initialData['app_name'] };
      storeEmitter.emit(INITIAL_DATA, state.shop);
    },
    AddNewNotification(state, message) {
      state.notifications.push(message);
    },
    removeNotification(state, key) {
      let pom = -1;
      for (let i = 0; i < state.notifications.length; i++) {
        if (!(state.notifications[i] === undefined)) {
          if (state.notifications[i].key == key) {
            pom = i;
            break;
          }
        }
      }
      if (pom >= 0) {
        delete state.notifications[pom];
      }
    }
  },
  actions: {
    clearTicket({ state }) {
      state.createdTicket = false;
    },

    async createTicket({ state, commit }, browserParams) {
      if (!state.createdTicket) {
        let initialData = await ApiClient.createTicket(browserParams);
        commit('initializeShop', initialData);
        state.createdTicket = initialData;
      }
      return state.createdTicket;
    },

    openRightWindowOffer({ commit, state }) {
      state.showRightWindow = true;
      state.showRightWindowOffer = true;
    },

    openRightWindow({ commit, state }) {
      state.showRightWindowOffer = false;
      state.showRightWindow = true;
    },

    closeRightWindow({ commit, state }) {
      state.showRightWindow = false;
      state.showRightWindowOffer = false;
    },

    addSuccessNotification({ commit }, message) {
      commit('addSuccessNotification', 'Wiadmość została wysłana');
    },

    closeSearchBlock({ state }) {
      state.searchBlock = false;
    },

    openSearchBlock({ state }) {
      state.searchBlock = !state.searchBlock;
    },


    emit({ }, event) {
      storeEmitter.emit(event.key, event.message);
    },

    addNotification({ commit }, message) {
      commit("AddNewNotification", message);
    },

    removeNotification({ commit }, key) {
      commit("removeNotification", key)
    }


  },
  plugins: [createPersistedState({
    paths: ["demo,logout"],
  })],
});




// WEBPACK FOOTER //
// ./src/state/store.js